import type { PortableTextComponents } from "@portabletext/react";

export const portableTextComponents: PortableTextComponents = {
  block: {
    normal: ({ children }) => {
      // Treat empty blocks (Enter with no content) as a line break
      const isEmpty =
        !children ||
        (Array.isArray(children) &&
          children.every(
            (child) => child === "" || child === null || child === undefined,
          ));
      if (isEmpty) return <br />;
      return <p>{children}</p>;
    },
  },
  list: {
    bullet: ({ children }) => <ul className="list-none pl-4">{children}</ul>,
    number: ({ children }) => <ol className="list-decimal pl-6 marker:text-core-orange">{children}</ol>,
  },
  listItem: {
    bullet: ({ children }) => (
      <li className="relative pl-4 before:content-['•'] before:absolute before:left-0 before:text-core-orange">
        {children}
      </li>
    ),
    number: ({ children }) => <li>{children}</li>,
  },
  hardBreak: () => <br />,
};

export const printPortableTextComponents: PortableTextComponents = {
  block: {
    normal: ({ children }) => {
      const isEmpty =
        !children ||
        (Array.isArray(children) &&
          children.every(
            (child) => child === "" || child === null || child === undefined,
          ));
      if (isEmpty) return <br />;
      return <p style={{ margin: 0 }}>{children}</p>;
    },
  },
  list: {
    bullet: ({ children }) => (
      <ul style={{ listStyle: "none", paddingLeft: 12, margin: 0 }}>{children}</ul>
    ),
    number: ({ children }) => (
      <ol style={{ paddingLeft: 16, margin: 0 }}>{children}</ol>
    ),
  },
  listItem: {
    bullet: ({ children }) => (
      <li style={{ position: "relative", paddingLeft: 12 }}>
        <span style={{ position: "absolute", left: 0, color: "#F36523" }}>{"\u2022"}</span>
        {children}
      </li>
    ),
    number: ({ children }) => <li>{children}</li>,
  },
  hardBreak: () => <br />,
};
